//
// Module for Recalc Benefit Differences Step for Death Benefit Setup wizards
//
rs.module("participant/benefit/setup/death/wizard/recalcbenefitdifferencestep",

    [],

    function () {

        // Initialize the module
        function initialize(jsSelectors, backendUrls) {

            // get JS selectors
            var stepContainer = $.js(jsSelectors.stepContainer);
            var recipientSelect = stepContainer.js(jsSelectors.recipientSelect, { required: false });
            var benefitDifferenceContentContainer = stepContainer.js(jsSelectors.benefitDifferenceContentContainer, { required: false });
            var loadingSpinner = stepContainer.js(jsSelectors.loadingSpinner, { required: false });

            // Hookup recipientSelect change event
            recipientSelect.change(recipientChanged);

            // Recipient selection changed
            function recipientChanged() {

                loadingSpinner.show();

                // Get the BenefitClaimPaymentKey of the selected recipient
                var selectedBenefitClaimPaymentKey = recipientSelect.val();

                // Swap out the Benefit Difference step content for the selected BenefitClaimPaymentKey
                $.get(backendUrls.getRecalcBenefitDifferenceForRecipient,
                    {
                        benefitClaimPaymentKey: selectedBenefitClaimPaymentKey
                    })
                    .done(function (html) {
                        benefitDifferenceContentContainer.html(html);
                    })
                    .always(function () {
                        loadingSpinner.hide();
                    });
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);